import { apiSlice } from '../../../../../app/apiSlice';

import configSiteUrls from '../../../configs/configSiteUrls';
import { PublicacaoOficial, PublicacaoOficialDTO, PublicacaoOficialList } from '../types/PublicacaoOficial';

//usei o publicacaoOficial como base

const endpointUrl = configSiteUrls.SITE_PUBLICACAO_OFICIAL_EP;

function getPublicacaoOficiais({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

function addPublicacaoOficial(obj: PublicacaoOficialDTO) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function deletePublicacaoOficial({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getPublicacaoOficial(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointUrl}/${id}`,
    method: 'GET'
  };
}
/** */

export const publicacaoOficialApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getPublicacaoOficiais: query<PublicacaoOficialList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getPublicacaoOficiais,
      providesTags: ['PublicacaoOficial']
    }),

    getPublicacaoOficial: query<PublicacaoOficial, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getPublicacaoOficial,
      providesTags: ['PublicacaoOficial']
    }),
    
    addPublicacaoOficial: mutation<void, PublicacaoOficialDTO>({
      query: addPublicacaoOficial,
      invalidatesTags: ['PublicacaoOficial']
    }),
    deletePublicacaoOficial: mutation<void, { id: string }>({
      query: deletePublicacaoOficial,
      invalidatesTags: ['PublicacaoOficial']
    })
  })
});
export const {
  useGetPublicacaoOficiaisQuery,
  useGetPublicacaoOficialQuery,
  useAddPublicacaoOficialMutation,
  useDeletePublicacaoOficialMutation
} = publicacaoOficialApiSlice;
